import React from "react";
import { Icon } from "@unite-us/ui";
import { PropTypes } from "prop-types";
function ProgramHeader(_ref) {
  var program = _ref.program,
    programStatus = _ref.programStatus;
  var programName = program.name,
    _program$provider = program.provider,
    provider = _program$provider === void 0 ? {} : _program$provider;
  var providerName = provider.name;
  var icon = programStatus.icon,
    color = programStatus.color,
    title = programStatus.title;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "font-black text-dark-blue underline"
  }, programName, " ", providerName && "(".concat(providerName, ")")), /*#__PURE__*/React.createElement("div", {
    className: "flex my-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    color: color,
    className: "mt-px"
  }), /*#__PURE__*/React.createElement("p", {
    className: "ml-2"
  }, title)));
}
ProgramHeader.propTypes = {
  program: PropTypes.shape({
    name: PropTypes.string.isRequired,
    provider: PropTypes.shape({
      name: PropTypes.string
    })
  }).isRequired,
  programStatus: PropTypes.shape({
    icon: PropTypes.string,
    color: PropTypes.string,
    title: PropTypes.string
  })
};
ProgramHeader.defaultProps = {
  programStatus: {
    icon: null,
    color: null,
    title: ""
  }
};
export default ProgramHeader;
//# sourceMappingURL=ProgramHeader.js.map